import { memo, useState } from "react";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { SI_PNI } from "./SI_PNI";
import { useTranslation } from "react-i18next";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { useFormContext } from "@4uhub/lib4uhub";
import { useIServiceType } from "../useIServiceType";
import { useParams } from "react-router-dom";

interface ISI_PNIWrapperProps {
  iServiceTypes: IIServiceType[];
}

const SI_PNI_IMAGE = { src: "/iServices/si-pni.png", alt: "SI-PNI" };

const translationPath = "page.4uBus.register.iService.";

export const SI_PNIWrapper = memo(({ iServiceTypes }: ISI_PNIWrapperProps) => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { setValue, getValues } = useFormContext<TIServiceForm>();

  const { si_pniParser, si_pniValues } = useIServiceType();

  const [isSelected, setIsSelected] = useState(() => {
    const si_pni = getValues("si_pni");
    return !!si_pni;
  });

  const saveConfigsJson = (v: TIServiceForm) => {
    const values = v.si_pni;
    if (!values) return;

    const configs = {
      authUrl: values.authUrl,
      baseUrl: values.baseUrl,
      responsibleDocument: values.responsibleDocument,
    };

    return configs;
  };

  const handleConfirm = () => {
    const companyDigitalCertificate = getValues(
      "si_pni.companyDigitalCertificate",
    );
    const iServiceType = iServiceTypes.find(
      (iServiceType) => iServiceType.code === si_pniValues.code,
    );
    if (iServiceType) {
      setValue("iServiceType", iServiceType);
    }
    setValue("companyDigitalCertificate", companyDigitalCertificate);
    setIsSelected(true);
  };

  const handleClearConfigs = () => {
    setValue("configs", null);
    setValue("companyDigitalCertificate", null);
    setValue("iServiceType", null);
    setIsSelected(false);
  };

  const handleOpen = () => {
    setValue("si_pni", si_pniValues.defaultValues);
  };

  const handleCloseSelected = () => {
    const configs = getValues("configs");
    const companyDigitalCertificate = getValues("companyDigitalCertificate");
    const si_pniValue = si_pniParser(configs, companyDigitalCertificate);
    setValue("si_pni", si_pniValue);
  };

  const isEditingScreen = !!id;

  return (
    <IServiceType
      img={SI_PNI_IMAGE}
      renderComponent={({ namePrefix }) => <SI_PNI namePrefix={namePrefix} />}
      isSelected={isSelected}
      isEditingScreen={isEditingScreen}
      getFormattedData={saveConfigsJson}
      onConfirm={handleConfirm}
      onClearConfigs={handleClearConfigs}
      onOpen={handleOpen}
      onCloseSelected={handleCloseSelected}
      iServiceTypeName="si_pni"
      serviceName={t(translationPath + "si_pni")}
    />
  );
});
